"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Constants_1 = require("./Constants");
class StatsigLocalStorage {
    static getItem(key) {
        var _a;
        try {
            if (typeof Storage !== 'undefined' &&
                typeof window !== 'undefined' &&
                window != null &&
                window.localStorage != null) {
                return window.localStorage.getItem(key);
            }
        }
        catch (e) { }
        return (_a = this.fallbackSessionCache[key]) !== null && _a !== void 0 ? _a : null;
    }
    static setItem(key, value) {
        try {
            if (typeof Storage !== 'undefined' &&
                typeof window !== 'undefined' &&
                window != null &&
                window.localStorage != null) {
                window.localStorage.setItem(key, value);
                return;
            }
        }
        catch (e) { }
        this.fallbackSessionCache[key] = value;
    }
    static removeItem(key) {
        try {
            if (typeof Storage !== 'undefined' &&
                typeof window !== 'undefined' &&
                window != null &&
                window.localStorage != null) {
                window.localStorage.removeItem(key);
                return;
            }
        }
        catch (e) { }
        delete this.fallbackSessionCache[key];
    }
    static cleanup() {
        try {
            if (typeof Storage !== 'undefined' &&
                typeof window !== 'undefined' &&
                window != null &&
                window.localStorage != null) {
                for (var key in window.localStorage) {
                    if (typeof window.localStorage[key] !== 'string') {
                        continue;
                    }
                    if (key == null || key in Constants_1.LOCAL_STORAGE_KEYS) {
                        continue;
                    }
                    if (key.substring(0, 21) !== 'STATSIG_LOCAL_STORAGE') {
                        continue;
                    }
                    window.localStorage.removeItem(key);
                }
            }
        }
        catch (e) { }
    }
}
exports.default = StatsigLocalStorage;
StatsigLocalStorage.fallbackSessionCache = {};
